export const LAYER_DEFS = [
  {
    id: 'natura2000',
    name: 'Natura 2000-gebieden',
    color: '#2ecc71',
    fillOpacity: 0.2,
    strokeColor: '#27ae60',
    strokeWidth: 2,
    strokeDasharray: [4, 3],
    visible: true,
    order: 1,
  },
  {
    id: 'buffer-zones',
    name: 'Bufferzones (5m)',
    color: '#3498db',
    fillOpacity: 0.15,
    strokeColor: '#2980b9',
    strokeWidth: 1.5,
    strokeDasharray: [4, 3],
    visible: false,
    order: 2,
  },
  {
    id: 'water',
    name: 'Waterdelen (BGT)',
    color: '#2980b9',
    fillOpacity: 0.5,
    strokeColor: '#1a5276',
    strokeWidth: 1,
    visible: false,
    order: 3,
  },
  {
    id: 'parcels',
    name: 'Landbouwpercelen (BRP)',
    color: '#27ae60',
    fillOpacity: 0.3,
    strokeColor: '#1e8449',
    strokeWidth: 1.5,
    visible: true,
    order: 4,
  },
];

export const GEWAS_COLORS = [
  { gewas: 'Sloot', color: '#2980b9', label: 'Sloot' },
  { gewas: 'Grasland, blijvend', color: '#4caf50', label: 'Grasland' },
  { gewas: 'Grasland, tijdelijk', color: '#4caf50', label: null },
  { gewas: 'Groene braak, spontane opkomst', color: '#aed581', label: 'Groene braak' },
  { gewas: 'Grasland, natuurlijk. Met landbouwactiviteiten.', color: '#8bc34a', label: 'Grasland, natuurlijk' },
  { gewas: 'Mais, snij-', color: '#ff9800', label: 'Mais' },
  { gewas: 'Natuurterreinen (incl. heide)', color: '#2e7d32', label: 'Natuurterrein' },
  { gewas: 'Houtwal en houtsingel', color: '#8d6e63', label: 'Houtwal/singel' },
  { gewas: 'Aardappelen, poot NAK', color: '#fdd835', label: 'Aardappelen, poot' },
  { gewas: 'Aardappelen, consumptie', color: '#ffb300', label: 'Aardappelen, consumptie' },
];
export const GEWAS_DEFAULT_COLOR = '#9e9e9e';

export const SELECTED_STYLE = {
  color: '#00e5ff',
  strokeWidth: 3,
  fillOpacity: 0.15,
};
